import { makeStyles } from "@material-ui/core/styles";

/**
 * Styling for the dedicated Send Receipt Page form body (`SendReceiptPanel`).
 *
 * Modeled on `useSendReceiptStyles` in
 * `components/MobilePayment/Receipts/Receipts.styles.js` but tuned for a
 * mobile-first, single-column, single-SEND layout: the email field, phone
 * field, delivery-method checkboxes, and SEND button stack vertically, the
 * fields and button are full-width, and the SEND button has a comfortable
 * touch target with clear separation from the controls above it.
 *
 * MUI v4 `makeStyles`; colors come from theme palette tokens only (no hardcoded
 * hex, no inline styles). Named `useSendReceiptPanelStyles` to avoid colliding
 * with the existing `useSendReceiptStyles` used by the inline `SendReceiptForm`.
 *
 * Requirements: 8.1 (usable at 320px, no horizontal scroll), 8.2 (vertical
 * stack), 8.3 (full-width SEND), 8.4 (control separation), 8.5 (touch targets),
 * 9.1 / 9.4 (MUI v4 makeStyles, theme tokens, no inline styles/hardcoded hex).
 */
export const useSendReceiptPanelStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    maxWidth: 400,
    margin: "0 auto",
    // Keep padding inside the element box so a 320px viewport never scrolls
    // horizontally.
    boxSizing: "border-box",
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      // Slightly tighter horizontal padding on the smallest screens so the
      // full-width controls stay comfortable at 320px without overflow.
      padding: theme.spacing(2, 1.5),
    },
  },
  // Vertical group wrapping a field and its associated delivery-method
  // checkbox, spaced so adjacent controls are clearly separated (Req 8.4).
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: theme.spacing(1),
  },
  input: {
    width: "100%",
  },
  checkboxGroup: {
    // Extra vertical breathing room around the checkbox so it is not flush
    // against the field above or the next control (reduces accidental touches).
    padding: theme.spacing(0.5, 0),
  },
  sendButton: {
    width: "100%",
    // Comfortable tap target for touch use (Req 8.5).
    minHeight: 48,
    // Separate the SEND button from the controls above it (Req 8.3, 8.4).
    marginTop: theme.spacing(2),
  },
}));
